import request from "@/utils/http"
import store from "@/store"
import { getCachedObj, removeCache } from "@/utils/cache"
import * as templateApi from "@/api/public/template"
import { cacheRequest } from "@/utils/decorator"

export function getSheet(sheetId, cache = true) {
  return sheetApi.getSheet(sheetId, cache)
}

export function getRawSheetDef(sheetId, cache = false) {
  if (store.getters.isTemplateMode) {
    return templateApi.getRawSheetDef(sheetId)
  }
  let reqFunc = () => request.get(`/sheet/getRawSheetDef`, { params: { sheetId } }).commonDeal()
  let key = `getRawSheetDef_${sheetId}`
  if (!cache) {
    removeCache(key)
  }
  return getCachedObj({ key, reqFunc })
}

export function getSheetDefForDetail(sheetId, dataId) {
  if (store.getters.isTemplateMode) {
    return templateApi.getSheetDefForDetail(sheetId, dataId)
  }
  return request.get(`/sheet/getSheetDefForDetail`, { params: { sheetId, dataId } }).commonDeal()
}

export function getSheetDefForEdit(sheetId, dataId) {
  if (store.getters.isTemplateMode) {
    return templateApi.getSheetDefForEdit(sheetId, dataId)
  }
  return request.get(`/sheet/getSheetDefForEdit`, { params: { sheetId, dataId } }).commonDeal()
}

export function getCalcRes(sheetData, step = 1) {
  if (store.getters.isTemplateMode) {
    return Promise.resolve({ data: {} })
  }
  return request.post(`/sheet/getCalcRes`, sheetData, { params: { step } }).commonDeal()
}

export function getAllSheet(appId) {
  return request.get("/sheet/allSheetInCurrentApp", { params: { appId } }).commonDeal()
}

/**
 * 获取当前APP所有工作表(无视图信息,速度快,体积小)
 * @returns {*}
 */
export function getSimpleSheetList(appId) {
  return request.get("/sheet/simpleSheetList", { params: { appId } }).commonDeal()
}

export function getAvailableSheets({ appId, cache = true } = {}) {
  return sheetApi.getAvailableSheets(appId, cache)
}

export function createSheet(sheet, appId) {
  return request
    .post(`/sheet/createSheet`, sheet, { params: { appId } })
    .commonDeal()
    .then(rsp => {
      sheetApi.getAvailableSheets(appId, false)
      return rsp
    })
}

export function updateSheet(sheet) {
  return request
    .post("/sheet/editSheet", sheet)
    .commonDeal()
    .then(rsp => {
      sheetApi.getAvailableSheets(rsp.appId, false)
      return rsp
    })
}

export function updateSheetLayout(layout) {
  return request.post("/sheet/layout/update", layout).commonDeal()
}

export function deleteSheetDef(sheetId, appId) {
  return request
    .post("/sheet/def/delete/" + sheetId)
    .commonDeal()
    .then(rsp => {
      sheetApi.getAvailableSheets(appId, false)
      return rsp
    })
}

export function getAllDefaultControls() {
  return sheetApi.getAllDefaultControls(true)
}

export function getGroupControls(cache = true) {
  return sheetApi.getGroupControls(cache)
}

export function updateSheetRule(sheetId, editedsheet) {
  return request.post(`/sheet/rule/update/${sheetId}`, editedsheet)
}

export function dealSheetRule(sheetId, sheetData) {
  return request.post(`/sheet/dealSheetRule/${sheetId}`, sheetData)
}

export function getCompanySheets(cache = true) {
  return sheetApi.getCompanySheets(cache)
}

export function previewSn(cid, name, str) {
  return request.get(`/sheet/previewSn`, { params: { cid, name, str } }).commonDeal()
}

export function getObjectId() {
  return request.get(`/sheet/getObjectId`).commonDeal()
}

// 讨论
export function deleteDiscussion(discussionId) {
  return request.post(`/sheet/deleteDiscussion`, null, { params: { discussionId } }).commonDeal()
}

export function getDiscussionList(dataId) {
  if (store.getters.isTemplateMode) return Promise.resolve([])
  return request.get(`/sheet/getDiscussionList`, { params: { dataId } }).commonDeal()
}

export function createDiscussion(discussion) {
  return request.post(`/sheet/createDiscussion`, discussion).commonDeal()
}

/**
 * 添加关联已有结构(树形工作表时使用)
 * @param sheetId
 * @param dataId
 * @param relatedDataId
 * @param cid
 * @returns {Promise<*>}
 */
export function addRelatedData(sheetId, dataId, relatedDataId, cid) {
  return request
    .get(`/sheet/addRelatedData`, { params: { sheetId, dataId, relatedDataId, cid } })
    .commonDeal()
}

export function getSheetGroup(appId, cache = false) {
  return sheetApi.getSheetGroup(appId, cache)
}

export function updateSheetGroups(sheetGroups, appId) {
  return request.post("sheet/group/update", sheetGroups, { params: { appId } }).commonDeal()
}

class SheetApi {
  @cacheRequest()
  getAvailableSheets(appId, cache) {
    return store.getters.isTemplateMode
      ? templateApi.getAvailableSheet(appId)
      : request.get("/sheet/getAvailable", { params: { appId } }).commonDeal()
  }

  @cacheRequest()
  getAllDefaultControls(cache) {
    return templateApi.getAllDefaultControls()
  }

  @cacheRequest()
  getCompanySheets(cache) {
    return request.get(`/sheet/getAllSheetInCurCompany`).commonDeal()
  }

  @cacheRequest()
  getSheet(sheetId, cache) {
    return store.getters.isTemplateMode
      ? templateApi.getSheet(sheetId)
      : request.get(`/sheet/getSheet`, { params: { sheetId } }).commonDeal()
  }

  @cacheRequest()
  getSheetGroup(appId, cache) {
    return request.get("/sheet/group/all", { params: { appId } }).commonDeal()
  }

  @cacheRequest()
  getGroupControls(cache) {
    return request.get("/sheet/group/controls").commonDeal()
  }
}
const sheetApi = new SheetApi()
